/* global axios */
import ApiClient from '../ApiClient';

class AilabAiHealth extends ApiClient {
  constructor() {
    super('ailab/ai_health', { accountScoped: true });
  }

  get({ hours = 24, queue } = {}) {
    return axios.get(this.url, { params: { hours, queue } });
  }
}

export default new AilabAiHealth();
